// File: frontend/src/components/UI/WALogo.jsx
// Official WA Contact Center Logo Component with real corporate logo

import React, { useState } from 'react';

const WALogo = ({
  size = 'md',
  variant = 'default',
  className = '',
  showText = true
}) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    'sm': 'h-6 w-auto',
    'md': 'h-8 w-auto',
    'lg': 'h-10 w-auto',
    'xl': 'h-12 w-auto'
  };

  const textSizeClasses = {
    'sm': 'text-sm',
    'md': 'text-base',
    'lg': 'text-lg',
    'xl': 'text-xl'
  };

  // Official WA Contact Center logo, self-hosted (evita el bloqueo de CSP por
  // cargar desde un dominio externo). Cae a un SVG local si la imagen fallara.
  const logoUrl = imageError
    ? '/logo-wa-real.svg'
    : '/logo-wa-oficial.png';

  const LogoIcon = ({ className: iconClassName }) => (
    <img
      src={logoUrl}
      alt="WA Contact Center"
      className={`${iconClassName} object-contain`}
      onError={() => setImageError(true)}
    />
  );

  if (!showText) {
    return <LogoIcon className={`${sizeClasses[size]} ${className}`} />;
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <LogoIcon className={sizeClasses[size]} />
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold text-wa-gray ${textSizeClasses[size]}`}>
            Contact Center
          </span>
          <span className={`text-xs text-wa-red font-medium -mt-1 ${
            size === 'sm' ? 'text-xs' : 'text-sm'
          }`}>
            CRM System
          </span>
        </div>
      )}
    </div>
  );
};

export default WALogo;